import React, { useRef, useState } from "react"

const MyTooltip = ({ label = "", children }) => {
  const tooltipRef = useRef(null)
  const childRef = useRef(null)
  const [position, setPosition] = useState({ top: 0, left: 0 })
  const [isVisible, setIsVisible] = useState(false)

  const handleMouseEnter = () => {
    if (tooltipRef.current) {
      // ใช้ setTimeout เพื่อให้แน่ใจว่า DOM ได้ render แล้ว
      setTimeout(() => {
        if (tooltipRef.current && childRef.current) {
          const rect = tooltipRef.current.getBoundingClientRect()
          const tooltipHeight = childRef.current.offsetHeight || 30
          const tooltipWidth = childRef.current.offsetWidth || 100
          
          // คำนวณตำแหน่งให้ tooltip อยู่กึ่งกลางเหนือปุ่ม
          const centerX = rect.left + (rect.width / 2)
          const leftPosition = centerX - (tooltipWidth / 2)
          
          setPosition({
            top: rect.top - tooltipHeight - 5, // 5px gap
            left: leftPosition
          })
          setIsVisible(true)
        }
      }, 0)
    }
  }

  const handleMouseLeave = () => {
    setIsVisible(false)
  }

  return (
    <span 
      className="my-tooltip-main"
      ref={tooltipRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
      <span 
        className="my-tooltip-child fadex" 
        ref={childRef}
        style={{
          position: 'fixed',
          top: `${position.top}px`,
          left: `${position.left}px`,
          opacity: isVisible ? 1 : 0,
          visibility: isVisible ? 'visible' : 'hidden',
          zIndex: 1100,
        }}
      >
        {label}
      </span>
    </span>
  )
}

export default MyTooltip
